export default __webpack_public_path__ + "static/media/return_home.bf8e6dbf.svg";